import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { LearningContentAPI } from '@chancenwerk/campus-learning-content/api/LearningContentAPI.js';
import { CampusExercise } from '@chancenwerk/campus-learning-content/entities/CampusExercise.js';
import { ChromiumDialog } from '@chancenwerk/design/components/cr-dialog.js';
import '@chancenwerk/design/components/cr-icon.js';
import { ChromiumSnackbar } from '@chancenwerk/design/components/cr-snackbar.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { switchMap } from 'rxjs';
import './../campus-component-section-lesson-list.js';

@customElement('campus-dialog-move-exercise')
export class CampusDialogMoveExercise extends ChromiumDialog<void> {
  @state() public exerciseToMove = new RXController(this, new CampusExercise({}));

  static override get element_name() {
    return 'campus-dialog-move-exercise';
  }

  @state() private readonly _lesson = new RXController(
    this,
    this.exerciseToMove.observable.pipe(
      switchMap(exercise => LearningContentAPI.getLessonForExercise(exercise._id)({})),
    ),
  );

  override heading = 'Aufgabe in eine andere Lektion verschieben';

  override content() {
    return html`<cr-flex space="md" padding="md" vertical>
      <campus-component-section-lesson-list
        .mode=${'custom'}
        .hideLessonsIDs=${[this._lesson.value?._id]}
        @lessonClicked=${async (e: CustomEvent) => {
          await LearningContentAPI.manipulation.exercise.moveToLesson(
            this.exerciseToMove.value._id,
            this._lesson.value?._id || '',
            e.detail.lesson._id,
          )();
          this.exerciseToMove.value.sortingOrderInLesson = 0;
          void ChromiumSnackbar.show('Aufgabe wurde erfolgreich verschoben');
          await this.close();
        }}
      ></campus-component-section-lesson-list>
    </cr-flex>`;
  }
}
